import QuestionAnswerRoundedIcon from "@mui/icons-material/QuestionAnswerRounded";

export const questionAnswer = (props) => {
  return <QuestionAnswerRoundedIcon {...props} />;
};
